import { render, staticRenderFns } from "./FacultiesBranchesManagement.vue?vue&type=template&id=7eabce7a"
import script from "./FacultiesBranchesManagement.vue?vue&type=script&lang=js"
export * from "./FacultiesBranchesManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports